import React from "react";
import { Link } from "react-router-dom";

/**
 * The bespoke cliqo logomark: an open "c" (for cliqo) meeting a click node —
 * a nod to the click/redirect the product is built around. The "c" inherits
 * colour via `currentColor` (set it with a text-* class); the click node is
 * always the flame accent, the brand's signature spark.
 */
export const CliqoMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
    {/* open "c" */}
    <path
      d="M15.86 7.4A6 6 0 1 0 15.86 16.6"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    {/* click node in the opening — flame accent */}
    <circle cx="16.4" cy="12" r="1.75" fill="hsl(var(--flame))" />
  </svg>
);

/**
 * cliqo logomark + wordmark, links to the marketing home page.
 * The wordmark is set in Bricolage Grotesque (the `font-brand` family).
 */
const Brand: React.FC = () => (
  <Link
    to="/"
    className="group flex items-center gap-2.5 text-foreground no-underline"
    aria-label="cliqo home"
  >
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-primary transition-transform duration-300 group-hover:-rotate-6">
      <CliqoMark className="h-5 w-5 text-primary-foreground" />
    </span>
    <span className="font-brand text-xl font-extrabold tracking-tight">
      cliqo
    </span>
  </Link>
);

export default Brand;